import React, { useEffect, useMemo, useState } from "react";
import Status from "../../../../request-dashboard/request/status/status";
import { MUITable } from "../../../../../common/components";
import Drawer from "@mui/material/Drawer";
import CompanyDashboardInitiativeAddDrawer from "../../../company-dashboard-initiative/company-dashboard-initiative-add-drawer/company-dashboard-initiative-add-drawer";
import addREC from "../../../../../assets/icons/addREC.svg";
import CompanyDashboardAddInitiativePopup from "../../company-dashboard-add-popup/company-dashboard-add-initiative-popup/company-dashboard-add-initiative-popup";
import "./company-dashboard-all-objective-drawer-main-content.scss";
import dayjs from "dayjs";
import editIcons from "../../../../../assets/icons/editIcons.svg";
import deleteRedIcons from "../../../../../assets/icons/delete-red.svg";
import CompanyDashboardEditInitiativePopup from "../../company-dashbaord-edit-popup/company-dashboard-edit-initiative-popup/company-dashboard-edit-initiative-popup";
import {
  deleteInitiativeById,
  getInitiativeById,
  getDepartmentOwners,
} from "../../../../../api/initiative";
import DeleteConfirmationPopup from "../../../../../common/components/delete-confirmation-popup/delete-confirmation-popup";
import { Tooltip, Typography } from "@mui/material";
import { usePermissions } from "../../../../../common/hooks/usePermissions";
import MODULES from "../../../../../constants/modules";
import reviewIcon from "../../../../../assets/icons/under_review_icon.svg";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

const CompanyDashboardAllObjectiveDrawerMainContent: any = (props: any) => {// NOSONAR
  const {
    listOfKeyResultsData,
    setListOfKeyResultsData,
    statusListInitiatives,
    employeesList,
    handleCreateInitiative,
    handleEditInitiative,

    objectId,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
    setLoading,
    statusListObjectives,
    statusListKeyResults,
    fetchObjectivesById,
  } = props;
  const [isOpenAddPopup, setIsOpenAddPopup] = useState(false);
  const [isShowInitiativeTableDrawer, setIsShowInitiativeTableDrawer] =
    useState(false);
  const [selectedInitiativesData, setSelectedInitiativesData] = useState<any[]>(
    [],
  );
  const [departmentsList, setDepartmentsList] = useState<any[]>([]);
  const [selectedMenuOption, setSelectedMenuOption] = useState(null);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [isOpenEditPopup, setIsOpenEditPopup] = useState(false);
  const [editInitiativeData, setEditInitiativeData] = useState<any>(null);
  const [deletePopupId, setDeletePopupId] = useState<number | null>(null);
  const [selectedInitiativeData, setSelectedInitiativeData] =
    useState<any>(null);
  const [keyResultId, setKeyResultId] = useState<number | null>(null);
  const {
    canRead: canReadInitiatives,
    canWrite: canWriteInitiatives,
    canEdit: canEditInitiatives,
    canDelete: canDeleteInitiatives,
  } = usePermissions(MODULES.INITIATIVES);

  useEffect(() => {
    const selectedKey = listOfKeyResultsData?.find(
      (data: any) => data?.isSelected,
    );

    if (selectedKey) {
      setSelectedInitiativesData(selectedKey?.initiatives || []);
    } else {
      const allInitiatives =
        listOfKeyResultsData?.flatMap((kr: any) => kr.initiatives || []) || [];

      const uniqueInitiatives: any = Array.from(
        new Map(allInitiatives.map((init: any) => [init.pk, init])).values(),
      );

      // Sort alphabetically by title
      const sortedInitiatives = uniqueInitiatives.toSorted(
        (a: { title?: string }, b: { title?: string }) => {
          const titleA = (a.title || "").toLowerCase();
          const titleB = (b.title || "").toLowerCase();
          return titleA.localeCompare(titleB);
        },
      );

      setSelectedInitiativesData(sortedInitiatives);
    }
  }, [listOfKeyResultsData]);

  const hasAnyKeyResults =
    Array.isArray(listOfKeyResultsData) && listOfKeyResultsData.length > 0;
  const selectedKey = listOfKeyResultsData?.find((d: any) => d?.isSelected);
  const canAddInitiative = !!selectedKey;
  let addInitiativeTooltip = "Add Initiative";
  if (!hasAnyKeyResults) {
    addInitiativeTooltip =
      "Please create a Key Result before adding an Initiative";
  } else if (!selectedKey) {
    addInitiativeTooltip = "Select a Key Result to add Initiatives";
  }

  const headers = [
    { key: "title", label: "Title" },
    { key: "startDate", label: "Start Date" },
    { key: "endDate", label: "End Date" },
    { key: "percentageComplete", label: "Percentage Complete" },
    { key: "status", label: "Status" },
  ];

  const handleOpenAddPopup = () => {
    setIsOpenAddPopup(true);
  };

  const handleCloseAddPopup = () => {
    setIsOpenAddPopup(false);
  };
  const handleCloseEditPopup = () => {
    setIsOpenEditPopup(false);
  };

  useEffect(() => {
    if (!isShowInitiativeTableDrawer) {
      fetchObjectivesById();
    }
  }, [isShowInitiativeTableDrawer, objectId]);
  const handleOpenEditPopup = async (id: any) => {
    try {
      const response = await getInitiativeById(id);
      setEditInitiativeData(response.data.data);
      setIsOpenEditPopup(true);
      setSelectedMenuOption(null);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDepartmentOwners = async () => {
    try {
      const response = await getDepartmentOwners();
      setDepartmentsList(response?.data?.data);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || "Failed to fetch initiative",
      );
      setAlertType("error");
      setAlertOpen(true);
    }
  };

  useEffect(() => {
    fetchDepartmentOwners();
  }, []);

  const handleOpenDeletePopup = (handleClose: () => void, row: any) => {
    setDeletePopupId(row.id);
    setIsDeletePopupOpen(!isDeletePopupOpen);
    handleClose();
  };

  const handleDelete = async () => {
    if (!deletePopupId) return;

    try {
      await deleteInitiativeById(deletePopupId);

      setIsDeletePopupOpen(false);
      setDeletePopupId(null);
      fetchObjectivesById();
    } catch (error) {
      console.error(error);
    }
  };
  const formattedData = useMemo(() => {
    if (
      Array.isArray(selectedInitiativesData) &&
      selectedInitiativesData.length > 0
    ) {
      return selectedInitiativesData.map((item: any) => {
        const statusText =
          typeof item?.status === "string"
            ? item.status
            : item?.status?.statusName || "-";
        const isApprovalPending = item?.isApproved === false;
        const isFaded = isApprovalPending;
        return {
          id: item.pk,
          title: item?.title || "-",
          startDate: item?.startDate
            ? dayjs(item.startDate).format("MM-DD-YYYY")
            : "-",
          endDate: item?.endDate
            ? dayjs(item.endDate).format("MM-DD-YYYY")
            : "-",
          percentageComplete: `${Math.round(item?.progress || 0)}%`,
          status: <Status status={statusText} />,
          owners: item?.owners,
          isInitiativePage: true,
          isFaded,
          isApprovalPending,
          data: item,
        };
      });
    }
    return [];
  }, [selectedInitiativesData]);

  const onRowClick = (rowData: any) => {
    setIsShowInitiativeTableDrawer(true);
    setSelectedInitiativeData(rowData);
  };

  if (!canReadInitiatives) {
    return (
      <div className="company-dashboard-all-objective-add-drawer-main-content">
        <div className="company-dashboard-all-objective-add-drawer-main-content-section">
          <div className="company-dashboard-all-objective-add-drawer-main-content-section-label">
            <Typography className="no-access-text">
              No access to this section
            </Typography>
          </div>
        </div>
      </div>
    );
  }

  const shouldShowEmptyState = selectedInitiativesData?.length === 0;
  const shouldShowInitiativeDrawer = isShowInitiativeTableDrawer;

  const renderMainContent = () => {
    if (shouldShowInitiativeDrawer) {
      return "";
    }
    if (shouldShowEmptyState) {
      return (
        <div className="company-dashboard-all-objective-add-drawer-main-content">
          <div className="company-dashboard-all-objective-add-drawer-main-content-section">
            <div className="company-dashboard-all-objective-add-drawer-main-content-section-label">
              <div>List Of Initiatives</div>
              {canWriteInitiatives && (
                <div>
                  {canAddInitiative ? (
                    <button
                      style={{
                        border: "none",
                        background: "none",
                        padding: 0,
                        cursor: "pointer",
                      }}
                      onClick={handleOpenAddPopup}
                    >
                      <img
                        src={addREC}
                        alt="Add"
                        style={{ cursor: "pointer" }}
                      />
                    </button>
                  ) : (
                    <Tooltip title={addInitiativeTooltip}>
                      <img
                        src={addREC}
                        alt="Add"
                        style={{ opacity: 0.4, cursor: "not-allowed" }}
                      />
                    </Tooltip>
                  )}
                </div>
              )}
            </div>
            <div className="company-dashboard-all-objective-add-drawer-main-content-add-section-content">
              <div className="company-dashboard-all-objective-add-drawer-main-content-add-section-content-label">
                You don&apos;t have any Initiatives
              </div>
              {canWriteInitiatives && (
                <div className="company-dashboard-all-objective-add-drawer-main-content-add-section-content-button">
                  {canAddInitiative ? (
                    <button onClick={handleOpenAddPopup}>
                      Add Initiatives
                    </button>
                  ) : (
                    <Tooltip title={addInitiativeTooltip}>
                      <span>
                        <button
                          style={{ opacity: 0.6, cursor: "not-allowed" }}
                          disabled
                        >
                          Add Initiatives
                        </button>
                      </span>
                    </Tooltip>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }
    return (
      <OverlayScrollbarsComponent
        className="company-dashboard-all-objective-drawer-main-content"
        options={{
          scrollbars: {
            theme: "os-theme-dark",
            autoHide: "scroll",
            autoHideDelay: 400,
          },
          overflow: {
            x: "hidden",
            y: "hidden", // disables vertical scroll
          },
        }}
      >
        <div className="company-dashboard-all-objective-drawer-main-content-section">
          <div className="company-dashboard-all-objective-add-drawer-main-content-section-label">
            <div>List Of Initiatives</div>
            {canWriteInitiatives && (
              <div>
                {canAddInitiative ? (
                  <button
                    style={{
                      border: "none",
                      background: "none",
                      padding: 0,
                      cursor: "pointer",
                    }}
                    onClick={handleOpenAddPopup}
                  >
                    <img
                      src={addREC}
                      alt="Close"
                      style={{ cursor: "pointer" }}
                    />
                  </button>
                ) : (
                  <Tooltip title={addInitiativeTooltip}>
                    <img
                      src={addREC}
                      alt="Close"
                      style={{ opacity: 0.4, cursor: "not-allowed" }}
                    />
                  </Tooltip>
                )}
              </div>
            )}
          </div>
          <div className="company-dashboard-all-objective-drawer-main-content-section-content">
            <MUITable
              columnNames={headers}
              rowsData={formattedData}
              onRowClick={onRowClick}
              showActionsColumnWithOptions={
                canEditInitiatives || canDeleteInitiatives
              }
              menuOptions={[
                ...(canEditInitiatives
                  ? [
                      {
                        label: "Edit",
                        onClick: (
                          handleMenuClose: () => void,
                          row: { id: any },
                        ) => {
                          handleOpenEditPopup(row.id);
                          handleMenuClose();
                        },
                        icon: editIcons,
                      },
                    ]
                  : []),
                ...(canDeleteInitiatives
                  ? [
                      {
                        label: <div style={{ marginLeft: "5px" }}>Delete</div>,
                        onClick: (
                          handleMenuClose: () => void,
                          row: { id: any },
                        ) => handleOpenDeletePopup(handleMenuClose, row),
                        icon: (
                          <img
                            src={deleteRedIcons}
                            alt="Delete"
                            style={{ width: 15, height: 15 }}
                          />
                        ),
                      },
                    ]
                  : []),
              ]}
              selectedMenuOption={selectedMenuOption}
              setSelectedMenuOption={setSelectedMenuOption}
              renderExpandedRow={(row: { isApprovalPending: boolean }) => {
                if (row.isApprovalPending) {
                  return (
                    <div
                      style={{
                        marginTop: "5px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <img alt="Under review icon" src={reviewIcon} />
                      <span>Under review</span>
                    </div>
                  );
                }
                return null;
              }}
            />
          </div>
        </div>
      </OverlayScrollbarsComponent>
    );
  };

  return (
    <>
      {renderMainContent()}
      <CompanyDashboardAddInitiativePopup
        isOpenAddPopup={isOpenAddPopup}
        onCancel={handleCloseAddPopup}
        listOfInitiativesData={listOfKeyResultsData}
        setListOfInitiativesData={setListOfKeyResultsData}
        selectedInitiativesData={selectedInitiativesData}
        setSelectedInitiativesData={setSelectedInitiativesData}
        statusListInitiatives={statusListInitiatives}
        employeesList={employeesList}
        onSave={handleCreateInitiative}
        departmentsList={departmentsList}
      />

      <CompanyDashboardEditInitiativePopup
        isOpenAddPopup={isOpenEditPopup}
        onCancel={handleCloseEditPopup}
        initiativeData={editInitiativeData}
        listOfInitiativesData={listOfKeyResultsData}
        setListOfInitiativesData={setListOfKeyResultsData}
        setSelectedInitiativesData={setSelectedInitiativesData}
        statusListInitiatives={statusListInitiatives}
        employeesList={employeesList}
        onSave={handleEditInitiative}
        departmentsList={departmentsList}
      />

      {isDeletePopupOpen && (
        <DeleteConfirmationPopup
          isOpen={true}
          onClose={() => {
            setIsDeletePopupOpen(false);
            setDeletePopupId(null);
          }}
          handleDelete={handleDelete}
          deleteId={deletePopupId}
        />
      )}

      <Drawer
        anchor={"bottom"}
        open={isShowInitiativeTableDrawer}
        onClose={(event, reason) => {
          if (reason === "backdropClick") {
            return;
          }
          setIsShowInitiativeTableDrawer(false);
          setSelectedInitiativeData(null);
        }}
      >
        <CompanyDashboardInitiativeAddDrawer
          setIsShowInitiativeDrawer={setIsShowInitiativeTableDrawer}
          employeesList={employeesList}
          setAlertMessage={setAlertMessage}
          setAlertType={setAlertType}
          setAlertOpen={setAlertOpen}
          setLoading={setLoading}
          initiativeId={selectedInitiativeData?.data?.pk}
          setInitiativeId={() => {}}
          objectiveId={objectId}
          setObjectiveId={() => {}}
          keyResultId={keyResultId}
          setKeyResultId={setKeyResultId}
          fetchInitiatives={() => {}}
          statusListKeyResults={statusListKeyResults}
          statusListObjectives={statusListObjectives}
          statusListInitiatives={statusListInitiatives}
          departmentsList={departmentsList}
        />
      </Drawer>
    </>
  );
};

export default CompanyDashboardAllObjectiveDrawerMainContent;
